<template>
  <div id="mian">
    <div class="header">
      <span
        @click="navClick('批量查询')"
        :class="crumbs == '批量查询' ? 'active' : ''"
        >批量查询</span
      >
      <span
        @click="navClick('订单查询')"
        :class="crumbs == '订单查询' ? 'active' : ''"
        >订单查询</span
      >
    </div>
    <!-- 批量订单查询 -->
    <div v-if="crumbs == '批量查询'">
      <!-- 上面表单框 -->
      <div class="con_from">
        <div class="lineP">
          <div class="item">
            <i>商户名称</i>
            <el-select
              v-model="query.keyword"
              filterable
              clearable
              :filter-method="searchMchList"
              @visible-change="unfoldMchList"
              @clear="clearMchList"
              @change="changeMch"
              placeholder="商户名称/店铺名称"
              :no-data-text="MerchantShopData=='' ? '无数据':'可搜索'"
            >
              <el-option
                v-for="item in MerchantShopData"
                :key="item.mchId"
                :label="item.mchName + ' | ' + item.mchId"
                :value="item.mchId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <i>产品类型</i>
            <el-select
              v-model="query.productId"
              placeholder="全部"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="(v, i) in productDrop"
                :key="i"
                :label="v.productName"
                :value="v.productId"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <i>退款状态</i>
            <el-select
              v-model="query.refundStatus"
              placeholder="全部"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="退款中" value="PROCESSING"></el-option>
              <el-option label="退款成功" value="SUCCESS"></el-option>
              <el-option label="退款失败" value="FAIL"></el-option>
            </el-select>
          </div>
        </div>
        <div class="lineP">
          <div class="item">
            <i>产品通道</i>
            <el-select
              v-model="query.payChannelId"
              placeholder="全部"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="(v, i) in channelsDrop"
                :key="i"
                :label="v.payChannelName"
                :value="v.payChannelId"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <i>交易退款金额</i>
            <!-- oninput="value=value.replace(/[^\d.]/g,'')" -->
            <el-input
              type="number"
              min="0"
              onKeypress="return(/[\d.]/.test(String.fromCharCode(event.keyCode)))"
              @input="inputnumStart"
              v-model="query.floorAmount"
              class="inputW"
            ></el-input>
            <span style="padding: 0 10px">-</span>
            <el-input
              type="number"
              min="0"
              onKeypress="return(/[\d.]/.test(String.fromCharCode(event.keyCode)))"
              @input="inputnumEnd"
              v-model="query.topAmount"
              class="inputW"
            ></el-input>
          </div>
        </div>
        <div class="lineP">
          <div class="item itemTime">
            <i>时间类型</i>
            <el-select
              v-model="query.timeType"
              style="width: 130px; "
            >
              <el-option label="创建时间" value="APPLY"></el-option>
              <el-option label="退款时间" value="REFUND"></el-option>
            </el-select>
            <span style="padding: 0 10px"></span>
            <el-date-picker
              v-model="query.startTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择时间"
            >
            </el-date-picker>
            <span style="padding-left: 10px; padding-right: 10px">-</span>
            <el-date-picker
              v-model="query.endTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择时间"
            >
            </el-date-picker>
          </div>
          <div class="itembtn">
            <el-button class="searchBt" @click="getLists">查询</el-button>
            <el-button class="outputBt" @click="outputShow" v-auth="'TRADE:RECEIPT:REFUNDS/EXPORT'">导出</el-button>
          </div>
        </div>
      </div>
      <!-- 中间交易账目 -->
      <!-- <div class="jiaoyi">
        <div class="jiaoyi_box" style="margin-right: 16px">
          <p><i>退款总数（笔）</i></p>
          <p>
            <b>{{ refundNum }}</b>
          </p>
        </div>
        <div class="jiaoyi_box">
          <p><i>退款金额（元）</i></p>
          <p>
            <b>{{ (refundAmount / 100) | formatMoney }}</b>
          </p>
        </div>
      </div> -->
      <data-panel :dataPanelList="tradeList"></data-panel>

      <div class="tab1">
        <table class="tab">
          <tr class="tab_title">
            <td>
              <p>创建时间</p>
              <p>退款时间</p>
            </td>
            <td>
              <p>商户名称</p>
              <p>店铺名称</p>
            </td>
            <td>
              <p>商户订单号</p>
              <p>交易流水号</p>
            </td>
            <td>
              <p>退款订单号</p>
              <p>退款流水号</p>
            </td>
            <td>
              <p>产品类型</p>
            </td>
            <td>
              <p>交易金额(元)</p>
            </td>
            <td>
              <p>交易退款金额(元)</p>
              <p>营销退款金额(元)</p>
            </td>
            <td style="width: 70px">
              <p>退款状态</p>
            </td>
            <td style="width: 80px">
              <p>操作</p>
            </td>
          </tr>
          <tr v-for="(v, i) in tabData" :key="i">
            <td>
              <p>{{ v.createTime }}</p>
              <p>{{ v.refundTime }}</p>
            </td>
            <td>
              <p>{{ v.mchName }}</p>
              <p>{{ v.storeName }}</p>
            </td>
            <td>
              <p>{{ v.mchOrderNo }}</p>
              <p>{{ v.plfOrderNo }}</p>
            </td>
            <td>
              <p>{{ v.mchRefundNo }}</p>
              <p>{{ v.plfRefundNo }}</p>
            </td>
            <td>
              <p>{{ v.productName }}</p>
            </td>
            <td>
              <p>{{ (v.orderAmount / 100) | formatMoney }}</p>
            </td>
            <td>
              <p>{{ (v.refundAmount / 100) | formatMoney }}</p> 
              <p>{{ (v.marketingRefundAmount / 100) | formatMoney }}</p> 
            </td>
            <td style="width: 70px">
              <p>{{ refundStatus[v.refundStatus] }}</p>
            </td>
            <td style="width: 80px">
              <p>
                <a
                  v-auth="'TRADE:RECEIPT:REFUNDS/DETAIL'"
                  href="javascript:;"
                  @click="showTab(v)"
                  class="lianjie"
                  >详情</a
                >
              </p>
              <p>
                <a
                  v-auth="'TRADE:RECEIPT:REFUNDS/SYNC'"
                  href="javascript:;"
                  class="lianjie"
                  @click="getSync(v.refundId, i)"
                  >同步</a
                >
                <i
                  v-auth="'TRADE:RECEIPT:REFUNDS/NOTIFY'"
                  v-if="v.refundStatus != 'PROCESSING'"
                  class="lianjie"
                  style="padding-left: 7px"
                  @click="getNotify(v.refundId)"
                  >通知</i
                >
              </p>
            </td>
          </tr>
        </table>
      </div>
      <el-pagination
        ref="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <!-- 按订单号查询 -->
    <div v-if="crumbs == '订单查询'">
      <div class="con_from">
        <div class="lineP">
          <!-- <i>退款订单号</i> -->
          <div class="item itemTwo">
            <el-select
              v-model="formData.orderNoType"
              placeholder=""
              style="width: 170px; margin-right: 20px"
            >
              <el-option value="mchRefundNo" label="退款订单号"></el-option>
              <el-option value="plfRefundNo" label="退款流水号"></el-option>
              <el-option value="mchOrderNo" label="商户订单号"></el-option>
              <el-option value="plfOrderNo" label="交易流水号"></el-option>
              <el-option value="upsOrderNo" label="三方订单号"></el-option>
              <el-option value="thdOrderNo" label="三方流水号"></el-option>
            </el-select>
            <el-input
              v-model="formData.orderNo"
              maxlength="128"
              style="width: calc(100% - 170px - 20px);"
              suffix-icon="el-icon-search"
              :placeholder="'搜索' + orderNoType[formData.orderNoType]"
            ></el-input>
          </div>
          <div class="itembtn itemTwobtn">
            <el-button class="searchBt" @click="getDetail">查询</el-button>
          </div>
        </div>
      </div>
      <div class="tab1" style="min-height: 700px">
        <table class="tab">
          <tr class="tab_title">
            <td>
              <p>创建时间</p>
              <p>退款时间</p>
            </td>
            <td>
              <p>用户名称</p>
              <p>店铺名称</p>
            </td>
            <td>
              <p>商户订单号</p>
              <p>交易流水号</p>
            </td>
            <td>
              <p>退款订单号</p>
              <p>退款流水号</p>
            </td>
            <td>
              <p>产品类型</p>
            </td>
            <td>
              <p>交易金额 (元)</p>
            </td>
            <td>
              <p>交易退款金额(元)</p>
              <p>营销退款金额(元)</p>
            </td>
            <td style="width: 70px">
              <p>退款状态</p>
            </td>
            <td style="width: 80px">
              <p>操作</p>
            </td>
          </tr>
          <tr v-for="(v, i) in tabData" :key="i">
            <td>
              <p>{{ v.createTime }}</p>
              <p>{{ v.refundTime }}</p>
            </td>
            <td>
              <p>{{ v.mchName }}</p>
              <p>{{ v.storeName }}</p>
            </td>
            <td>
              <p>{{ v.mchOrderNo }}</p>
              <p>{{ v.plfOrderNo }}</p>
            </td>
            <td>
              <p>{{ v.mchRefundNo }}</p>
              <p>{{ v.plfRefundNo }}</p>
            </td>
            <td>
              <p>{{ v.productName }}</p>
            </td>
            <td>
              <p>{{ (v.orderAmount / 100) | formatMoney }}</p>
            </td>
            <td>
              <p>{{ (v.refundAmount / 100) | formatMoney }}</p>
              <p>{{ (v.marketingRefundAmount / 100) | formatMoney }}</p>
            </td>
            <td style="width: 70px">
              <p>{{ refundStatus[v.refundStatus] }}</p>
            </td>
            <td style="width: 80px">
              <p>
                <a href="javascript:;" @click="showTab(v)" class="lianjie"
                  >详情</a
                >
              </p>
              <p>
                <a
                  v-auth="'TRADE:RECEIPT:REFUNDS/SYNC'"
                  href="javascript:;"
                  class="lianjie"
                  @click="getSync(v.refundId, i)"
                  >同步</a
                >
                <i
                  v-auth="'TRADE:RECEIPT:REFUNDS/NOTIFY'"
                  v-if="v.refundStatus != 'PROCESSING'"
                  class="lianjie"
                  style="padding-left: 7px"
                  @click="getNotify(v.refundId)"
                  >通知</i
                >
              </p>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <el-dialog title="导出退款记录" :visible.sync="outPayShow" width="490px">
      <ul class="overAccount_ul">
        <li class="ul_left">
          <div class="overAccount_ul_title">商户名称</div>
          <el-select v-model="outputForm.mchId" placeholder="选择商户">
            <el-option
              v-for="v in mchDrop"
              :key="v.mchId"
              :label="v.mchName"
              :value="v.mchId"
            ></el-option>
          </el-select>
          <div class="overAccount_ul_title" v-show="selectTimeType == -1">
            <i>*</i>开始日期
          </div>
          <el-date-picker
            style="width: 200px; height: 36px"
            v-model="outputForm.startDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择时间"
            v-show="selectTimeType == -1"
            :disabled="selectTimeType != -1"
          >
          </el-date-picker>
        </li>
        <li class="ul-right">
          <div class="overAccount_ul_title"><i>*</i>交易日期</div>
          <el-select
            v-model="selectTimeType"
            @change="timeChange"
            placeholder="选择交易日期"
          >
            <el-option label="今天" value="1"></el-option>
            <el-option label="昨天" value="2"></el-option>
            <el-option label="近7天" value="7"></el-option>
            <el-option label="其它" value="-1"></el-option>
          </el-select>
          <div class="overAccount_ul_title" v-show="selectTimeType == -1">
            <i>*</i>结束日期
          </div>
          <el-date-picker
            style="width: 200px; height: 36px"
            :picker-options="endOption"
            v-model="outputForm.endDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择时间"
            v-show="selectTimeType == -1"
            :disabled="selectTimeType != -1"
          >
          </el-date-picker>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button class="exitBt" @click="outPayShow = false">取 消</el-button>
        <el-button class="addBt" @click="output">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { formatDate } from "@/utils/common.js";
import {
  getRefunds,
  getRefundsSearch,
  getReResync,
  setReReNotify,
  exportRefunds,
} from "@/api/trading/gathering.js";
import {
  payproductsDrop,
  paychannelsDrop,
  merchantsDrop,MerchantShopDrop
} from "@/api/common.js";
import { URL_API } from "@/utils/apiUrl.js";
import { mapState, mapMutations } from "vuex";
import dataPanel from "../../../../components/dataPanel/index.vue";

export default {
  data() {
    let that = this;
    return {
      query: {
        startTime: formatDate(+new Date(), "yyyy-MM-dd 00:00:00"),
        endTime: formatDate(+new Date(), "yyyy-MM-dd 23:59:59"),
        timeType: "APPLY",
        pageNo: 1,
        pageSize: 10,
        productId: "",
        refundStatus: "",
        keyword: "",
        payChannelId: "",
      },
      totalNum: 0,
      // refundNum: 0,
      // refundAmount: 0,
      formData: {
        orderNoType: "mchRefundNo",
        orderNo: "",
      },
      tradeList: [], //交易笔数和交易金额数据

      orderNoType: {
        mchRefundNo: "退款订单号",
        plfRefundNo: "退款流水号",
        mchOrderNo: "商户订单号",
        plfOrderNo: "交易流水号",
        upsOrderNo: "三方订单号",
        thdOrderNo: "三方流水号",
      },
      productDrop: [],
      channelsDrop: [],
      tabData: [],
      refundStatus: {
        SUCCESS: "退款成功",
        FAIL: "退款失败",
        PROCESSING: "退款中",
      },
      crumbs: "批量查询",
      endOption: {
        disabledDate(date) {
          return (
            date.getTime() <
              new Date(that.outputForm.startDate) - 24 * 60 * 60 * 1000 ||
            date.getTime() >
              new Date(
                +new Date(that.outputForm.startDate) + 30 * 24 * 60 * 60 * 1000
              )
          );
        },
      },
      outPayShow: false, //导出展示
      outputForm: {}, //导出信息
      selectTimeType: "", //导出时间类型
      mchDrop: [], //商户列表

      MerchantShopData: [], //分账商户名称/编号可选项
      keywordData:{
        mchId:"",
        mchName:"",
      },

    };
  },
  computed: {
    ...mapState({
      refundDetail: "trading_refund",
    }),
  },
  created() {
    if (this.refundDetail) {
      this.query = this.refundDetail.query;
      this.formData = this.refundDetail.formData;
      this.keywordData = this.refundDetail.keywordData;
    }
    if(JSON.stringify(this.keywordData) != '{}' && this.keywordData != undefined && this.keywordData.mchId != ""){
      this.query.keyword = this.keywordData.mchName + ' | ' + this.keywordData.mchId;
    }
    this.$nextTick(() => {
      this.$refs.pagination.internalCurrentPage = this.query.pageNo;
    });
    this.getDrop();
    this.getLists(false);
    this.$enter(this.$route.path, this.search);
  },
  methods: {
    ...mapMutations({
      setRefund: "trading_setRefund",
    }),
    search() {
      if (this.crumbs == "批量查询") {
        this.getLists();
      } else {
        this.getDetail();
      }
    },
    
    //搜索-交易金额
    inputnumStart(e){
      if(e == -1){
        this.query.floorAmount = "";
      }else{
        if(!(/^(\d?)+(\.\d{0,2})?$/.test(e))){  
          e = e.substring(0, e.length - 1); 
          this.$message.error("请输入小数点后两位");
        }
        this.query.floorAmount = e;
      }
    },
    inputnumEnd(e){
      if(e == -1){
        this.query.topAmount = "";
      }else{
        if(!(/^(\d?)+(\.\d{0,2})?$/.test(e))){  
          e = e.substring(0, e.length - 1); 
          this.$message.error("请输入小数点后两位");
        }
        this.query.topAmount = e;
      }
    },

    // 获取详情
    getLists(reset = true) {
      if (reset) {
        this.query.pageNo = 1;
      }
      let query = { ...this.query };
      query.floorAmount = query.floorAmount
        ? this.accMul(query.floorAmount, 100)
        : "";
      query.topAmount = query.topAmount
        ? this.accMul(query.topAmount, 100)
        : "";
      // query.keyword = query.keyword.trim();

      if(this.keywordData != undefined && this.keywordData.mchId != ""){
        query.keyword = this.keywordData.mchId;
      }

      getRefunds(query).then((res) => {
        if (res.resultStatus) {
          if (this.crumbs == "批量查询") {
            this.tradeList = [];
            this.tabData = res.resultData.refunds;
            if (this.tabData.length == 0) {
              this.$message({
                message: "暂无数据",
                duration: 1500,
              });
            }
            this.totalNum = res.resultData.totalNum;
            // this.refundNum = res.resultData.refundNum;
            // this.refundAmount = res.resultData.refundAmount;
            this.tradeList.push(
              {
                title: "退款总数（笔）",
                value: res.resultData.refundNum,
                type: 1,
              },
              {
                title: "交易退款金额（元）",
                value: res.resultData.refundAmount,
                type: 2,
              }
            );
          }
        }
      });
    },
    //  处理计算失真
    accMul(arg1, arg2) {
      var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      return (
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
        Math.pow(10, m)
      );
    },
    // 导出展示
    outputShow() {
      this.outPayShow = true;
      this.outputForm = {
        startDate: "",
        endDate: "",
        mchId: "",
      };
      this.selectTimeType = "";
    },
    // 选择时间类型
    timeChange(value) {
      switch (value) {
        case "1":
          this.outputForm.startDate = formatDate(+new Date(), "yyyy-MM-dd");
          this.outputForm.endDate = formatDate(+new Date(), "yyyy-MM-dd");
          break;
        case "2":
          this.outputForm.startDate = formatDate(
            +new Date() - 24 * 60 * 60 * 1000,
            "yyyy-MM-dd"
          );
          this.outputForm.endDate = formatDate(
            +new Date() - 24 * 60 * 60 * 1000,
            "yyyy-MM-dd"
          );
          break;
        case "7":
          this.outputForm.startDate = formatDate(
            +new Date() - 6 * 24 * 60 * 60 * 1000,
            "yyyy-MM-dd"
          );
          this.outputForm.endDate = formatDate(+new Date(), "yyyy-MM-dd");
          break;
        case "-1":
          this.outputForm.startDate = "";
          this.outputForm.endDate = "";
          break;
      }
    },
    // 导出
    output() {
      if (!this.outputForm.startDate || !this.outputForm.endDate) {
        this.$message.error("导出时间段必选");
        return;
      }
      let data = this.outputForm;
      exportRefunds(data).then((res) => {
        if (res) {
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", "退款查询.csv");
          document.body.appendChild(link);
          link.click();
        }
      });
      this.outPayShow = false;
    },
    // 获取搜索详情
    getDetail() {
      let params = {
        orderNoType: this.formData.orderNoType,
        orderNo: this.formData.orderNo.trim(),
      };
      if (!params.orderNo) {
        return this.$message.error(
          "请输入" + this.orderNoType[this.formData.orderNoType]
        );
      }
      getRefundsSearch(params).then((res) => {
        if (res) {
          if (this.crumbs == "订单查询") {
            this.tabData = res.resultData;
            if (this.tabData.length == 0) {
              this.$message({
                message: "暂无数据",
                duration: 1500,
              });
            }
          }
        }
      });
    },
    // 获取下拉
    getDrop() {
      payproductsDrop().then((res) => {
        if (res.resultStatus) {
          this.productDrop = res.resultData;
        }
      });
      paychannelsDrop().then((res) => {
        if (res.resultStatus) {
          this.channelsDrop = res.resultData;
        }
      });
      merchantsDrop().then((res) => {
        if (res.resultStatus) {
          this.mchDrop = res.resultData;
        }
      });
    },
    //菜单切换
    navClick(data) {
      this.crumbs = data;
      this.tabData = [];
      if (data == "批量查询") {
        this.getLists();
      } else {
        if (this.formData.orderNo) {
          this.getDetail();
        }
      }
    },
    // 同步
    getSync(id, index) {
      getReResync(id).then((res) => {
        if (res.resultStatus) {
          this.tabData[index].refundStatus = res.resultData.orderStatus;
          this.$message.success("同步请求成功");
        }
      });
    },
    // 通知
    getNotify(id) {
      setReReNotify(id).then((res) => {
        if (res.resultStatus) {
          this.$message.success("通知请求成功");
        }
      });
    },
    // 跳转详情
    showTab(value) {
      this.$router.push({
        name: "reund_xq",
        query: {
          id: value.refundId,
        },
      });
    },
    // 获取商户下拉列表
    _searchAllMch(value) {
      this.MerchantShopData = [];
      let params = {
        keyword: value,
      };
      MerchantShopDrop(params).then((res) => {
        if (res.resultStatus) {
          this.MerchantShopData = res.resultData;
          console.log(this.MerchantShopData);
        }
      });
    },
    // 商户下拉列表输入搜索内容时
    searchMchList(val) {
      if (val) {
        let value = val;
        this._searchAllMch(value);
      } else {
        // 搜索内容为空时还原列表
        this._searchAllMch();
      }
    },
    // 商户下拉框展开/收起时触发
    unfoldMchList(e) {
      if (e) {
        //  展开时
        this._searchAllMch();
      } else {
        //  折叠时
        this.MerchantShopData = [];
      }
    },
    // 商户下拉搜索框清空搜索内容时
    clearMchList() {
      this.query.keyword = ""; //清空选中的商户id
      this.keywordData = {};
      this._searchAllMch(); //重新获取所有商户下拉列表
    },
    changeMch(e) {
      this.query.keyword = e;
      let mchId  = this.query.keyword;
      console.log( this.query.keyword );
      let result = this.MerchantShopData.filter(e=>e.mchId === mchId)
      if(result && result.length > 0){
        console.log(result[0])
        this.keywordData = result[0];
      }
    }, 

    // 页面大小改变
    handleSizeChange(size) {
      this.query.pageSize = size;
      this.getLists();
    },
    handleCurrentChange(page) {
      this.query.pageNo = page;
      this.getLists(false);
    },
  },
  beforeDestroy() {
    let data = {
      query: this.query,
      formData: this.formData,
      keywordData: this.keywordData,
    };
    this.setRefund(data);
  },
  components: {
    dataPanel,
  },
};
</script>
<style scoped>
.con_from .lineP .item{
  width: 29%;
  margin-left: 6.5%;
}
.con_from .lineP .item:first-child{
  margin-left: 0%;
}
.con_from .lineP .item i {
  width: 92px;
}
.con_from .lineP .itemTime{
  width: 64.51%;
}
.con_from .lineP .item .el-input , .con_from .lineP .item .el-select{
  width: calc(100% - 92px - 10px);
}
.con_from .lineP .itemTime .el-input{
  width: calc((100% - 130px - 92px - 44.67px - 10px) / 2);
}
.con_from .lineP .item .inputW {
  width: calc((100% - 92px - 24.67px - 10px) / 2);
}
.con_from .lineP .item .inputW ::v-deep .el-input__inner{
  padding: 0px 0px 0px 15px !important;
}
.con_from .lineP .itemTwo {
    width: 38% !important;
}
.addBt {
  width: 60px;
  height: 32px;
  background-color: #48b8b6;
  color: #ffffff;
  font-size: 12px;
  padding: 0;
}

.exitBt {
  width: 60px;
  height: 32px;
  background-color: #ffffff;
  color: #333333;
  font-size: 12px;
  padding: 0;
}

.overAccount_ul {
  overflow: hidden;
}

.overAccount_ul_title {
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  color: #999999;
}
.overAccount_ul_title i {
  color: #48b8b6;
}

.overAccount_ul .el-input,
.overAccount_ul .el-select {
  margin-bottom: 7px;
}

.ul_left {
  float: left;
  width: 200px;
  margin-left: 24px;
}

.ul-right {
  float: right;
  width: 200px;
  margin-right: 26px;
}
</style>
